import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 mb-8 border-b border-gray-40" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3 text-xl font-bold" }, "Our Packages and Inclusions", -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex items-center justify-between w-full py-2" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "mb-1 font-bold text-primary-500" }
const _hoisted_9 = { class: "font-bold text-primary-700" }
const _hoisted_10 = {
  key: 0,
  class: "px-5 pt-0 pb-6"
}
const _hoisted_11 = { class: "w-full space-y-2" }
const _hoisted_12 = { class: "pl-6 list-disc" }
const _hoisted_13 = { class: "mt-4 text-right" }
const _hoisted_14 = {
  key: 1,
  class: "mb-10"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3 text-xl font-bold" }, "Our Other Individual Services", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "You may avail these individually or as add-on. If none, you may skip to the next step.", -1)
const _hoisted_17 = { class: "flex flex-wrap -m-2" }
const _hoisted_18 = { class: "bg-white rounded-2xl" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "font-bold text-primary-500" }
const _hoisted_21 = {
  key: 0,
  class: "px-5 pt-0 pb-6"
}
const _hoisted_22 = { class: "w-full space-y-2" }
const _hoisted_23 = { class: "flex items-center justify-between" }
const _hoisted_24 = { class: "relative flex" }
const _hoisted_25 = { class: "flex items-center h-4 mt-0.5" }
const _hoisted_26 = ["id", "value"]
const _hoisted_27 = { class: "ml-3 text-sm" }
const _hoisted_28 = ["for"]
const _hoisted_29 = { class: "font-bold whitespace-nowrap" }
const _hoisted_30 = { class: "relative flex" }
const _hoisted_31 = { class: "flex items-center h-4 mt-0.5" }
const _hoisted_32 = ["id", "value"]
const _hoisted_33 = { class: "ml-3 text-sm" }
const _hoisted_34 = ["for"]
const _hoisted_35 = { class: "whitespace-nowrap" }
const _hoisted_36 = {
  key: 2,
  class: "mb-10"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-xl font-bold" }, "Allergy Test", -1)
const _hoisted_38 = { class: "flex flex-wrap -m-2" }
const _hoisted_39 = { class: "bg-white rounded-2xl" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "font-bold text-primary-500" }
const _hoisted_42 = {
  key: 0,
  class: "px-5 pt-0 pb-6"
}
const _hoisted_43 = { class: "w-full space-y-2" }
const _hoisted_44 = { class: "flex items-center justify-between" }
const _hoisted_45 = { class: "relative flex" }
const _hoisted_46 = { class: "flex items-center h-4 mt-0.5" }
const _hoisted_47 = ["id", "value"]
const _hoisted_48 = { class: "ml-3 text-sm" }
const _hoisted_49 = ["for"]
const _hoisted_50 = { class: "font-bold whitespace-nowrap" }
const _hoisted_51 = { class: "relative flex" }
const _hoisted_52 = { class: "flex items-center h-4 mt-0.5" }
const _hoisted_53 = ["id", "value"]
const _hoisted_54 = { class: "ml-3 text-sm" }
const _hoisted_55 = ["for"]
const _hoisted_56 = { class: "whitespace-nowrap" }
const _hoisted_57 = { class: "justify-between hidden w-full mt-auto text-right lg:flex" }
const _hoisted_58 = ["innerHTML"]

import BookingLayout from '@/layouts/BookingLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import AccordionComponent from '@/components/AccordionComponent.vue';

import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import Storage from '@/helpers/storage';

import { useRouter } from 'vue-router';
import { onMounted, ref, watch } from 'vue';

import booking from "@/classes/Booking";
import { useBookingStore } from '@/store/booking';
import { formatter } from "@/helpers/NumberHelper";

import { ChevronDownIcon } from '@heroicons/vue/20/solid'
// Router Instance

export default /*#__PURE__*/_defineComponent({
  __name: 'ChoosePackage',
  setup(__props) {

const router = useRouter();

// State Instance
const bookingStoreState = useBookingStore();

// Local Storage Instance
const bookingLocalStorage = new Storage();
const bookingLocalStoragePayload = ref(JSON.parse(bookingLocalStorage.get('bookingPayload')));
const bookingLocalStorageSummary = ref(JSON.parse(bookingLocalStorage.get('bookingSummary')));

// Data
const loader = ref(false);
const showError = ref(false);
const errorMsg = ref(null);
const selectedPackageId = ref(null)
const canContinue = ref(false)

const packages = ref<any>([]);
const services = ref<any>([]);
const allergyTests = ref<any>([]);

const selectedRiders = ref([]);
const selectedAllRiders = ref([]);
const oldSelectedAllRiders = ref([]);

// Methods
const fetchPackages = async () => {
    loader.value = true

    await booking.getPackages()
        .then((result: any) => {
            loader.value = false
            packages.value = result.data.response;     
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const fetchServices = async () => {
    loader.value = true

    await booking.getServices()
        .then((result: any) => {
            loader.value = false
            services.value = result.data.response;            
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const fetchAllergyTests = async () => {
    loader.value = true

    await booking.getAllergyTests()
        .then((result: any) => {
            loader.value = false
            allergyTests.value = result.data.response;            
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const fetchDrafts = () => {
    bookingStoreState.bookingPayload = bookingLocalStoragePayload.value || bookingStoreState.bookingPayload;
    bookingStoreState.bookingSummary = bookingLocalStorageSummary.value || bookingStoreState.bookingSummary;
    
    selectedPackageId.value = bookingStoreState.bookingPayload.package_id;
    if(selectedPackageId.value || bookingStoreState.bookingPayload.other_charges_line) {
        canContinue.value = true;
    }
    
    selectedRiders.value = bookingStoreState.bookingPayload?.other_charges_line.map((rider:any) => rider.item_id);

    if(!bookingStoreState.bookingPayload.branch_id && !bookingStoreState.bookingPayload.patient_id) {
        router.push('/booking')
    }
}

const saveDrafts = () => {
    bookingLocalStorage.set('bookingPayload', JSON.stringify(bookingStoreState.bookingPayload));
    bookingLocalStorage.set('bookingSummary', JSON.stringify(bookingStoreState.bookingSummary));
}

const fetchDisabledDates = () => {
    loader.value = true;

    const payload = {
        package: bookingStoreState.bookingPayload.package_name,
        riders: bookingStoreState.bookingPayload.riders,
    }
    
    booking.getGetAvailableDates(payload)
        .then(({data}: any) => {
            loader.value = false
            bookingStoreState.disableDates = data.response;  
            saveDrafts();
            router.push('/booking/select-date-and-time');
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const selectedPackage = (packageId: any) =>  {
    bookingStoreState.canSubmitBooking = false;
    bookingStoreState.bookingSummary.selectedDate = null;
    bookingStoreState.bookingSummary.selectedTime = null;
    
    if(selectedPackageId.value == packageId) {
        bookingStoreState.bookingPayload.package_id = 0;
        bookingStoreState.bookingPayload.package_name = null;
        bookingStoreState.bookingPayload.package_fee = 0;
        bookingStoreState.bookingSummary.selectedPackage = null;
        bookingStoreState.bookingSummary.packageFee = null;
        bookingStoreState.bookingSummary.totalFee = bookingStoreState.bookingSummary.miscFee + bookingStoreState.bookingSummary.packageFee;
    
        selectedPackageId.value = null;
        
        if(bookingStoreState.bookingPayload.other_charges_line === null) {
            canContinue.value = false;
        }
    } else {
        const filteredPackage = packages.value.find(x => x.id == packageId);
        
        bookingStoreState.bookingPayload.package_id = filteredPackage.id;
        bookingStoreState.bookingPayload.package_name = filteredPackage.name;
        bookingStoreState.bookingPayload.package_fee = filteredPackage.price;
        bookingStoreState.bookingSummary.selectedPackage = filteredPackage.name;
        bookingStoreState.bookingSummary.packageFee = filteredPackage.price;
        bookingStoreState.bookingSummary.totalFee = bookingStoreState.bookingSummary.miscFee + bookingStoreState.bookingSummary.packageFee;
    
        selectedPackageId.value = bookingStoreState.bookingPayload.package_id;
        
        if(selectedPackageId.value && bookingStoreState.bookingPayload.other_charges_line === null) {
            canContinue.value = true;
        }
    }
}

watch(() => selectedRiders.value, (val) => {

    const riders = services.value.concat(allergyTests.value);

    let filteredRiders = [];
    const otherChargesLine = [];
    const rider_item_ids = [];
    const rider_names = [];
    
    riders.forEach((rider:any) => {
        filteredRiders = filteredRiders.concat(rider.items.filter(obj => val.includes(obj.item_id)));
    });

    filteredRiders.forEach(filteredRider => {
        const obj = {
            item_id: null,
            price: null,
        };
        obj.item_id = filteredRider.item_id;
        obj.price = filteredRider.item_price;
        otherChargesLine.push(obj)
        rider_item_ids.push(filteredRider.item_id)
    });

    riders.forEach(rider => {
        const item = rider.items.filter(obj => rider_item_ids.includes(obj.item_id));
        if(item.length > 0) {
            item.forEach(a => rider_names.push(a.item_name));
        }
    });

    bookingStoreState.canSubmitBooking = false;
    bookingStoreState.bookingSummary.selectedDate = null;
    bookingStoreState.bookingSummary.selectedTime = null;
    bookingStoreState.bookingPayload.other_charges_line = otherChargesLine;
    bookingStoreState.bookingPayload.riders = rider_names;
    bookingStoreState.bookingPayload.other_charges_fee = filteredRiders.reduce((a, b) => a + b.item_price, 0);
    bookingStoreState.bookingSummary.selectedAddOns = filteredRiders;
    bookingStoreState.bookingSummary.miscFee = filteredRiders.reduce((a, b) => a + b.item_price, 0);
    bookingStoreState.bookingSummary.totalFee = bookingStoreState.bookingSummary.miscFee + bookingStoreState.bookingSummary.packageFee;

    if(bookingStoreState.bookingPayload.other_charges_line.length > 0) {
        canContinue.value = true;
    } else if(!bookingStoreState.bookingPayload.package_id){
        canContinue.value = false;
    }

});

watch(() => selectedAllRiders.value, (val) => {
    // TODO : Unselect All
    // checkForUnAllRiders();

    const riders = services.value.concat(allergyTests.value);
    const selectedParentRiders = riders.filter(obj => val.includes(obj.id));

    // selectedRiders.value = [];
    selectedParentRiders.forEach(selectedParentRider => {
        const riderIds = selectedParentRider.items.map(a => a.item_id)
        selectedRiders.value = selectedRiders.value.concat(riderIds);
    });

    oldSelectedAllRiders.value = selectedAllRiders.value;
});

const checkForUnAllRiders = () => {
    console.log(oldSelectedAllRiders.value);
}

const proceed = () => {
    if(canContinue.value) {
        fetchDisabledDates()
    }
}

const back = () => {
    router.push('/booking');
}

const isActive = ref(null);
const toggleItem = (index: any) => {
    if(isActive.value == index) {
        isActive.value = null;
    } else {
        isActive.value = index;
    }
}

onMounted( async () => {
    await fetchPackages();
    await fetchServices();
    await fetchAllergyTests();
    fetchDrafts();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BookingLayout, {
    "previous-step": "1",
    step: "2",
    selected: selectedPackageId.value,
    onProceed: proceed,
    onBack: back
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          ( packages.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packages.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "rounded-2xl bg-white mb-2.5"
                  }, [
                    _createElementVNode("div", {
                      class: "flex items-center justify-between w-full px-5 py-4 cursor-pointer",
                      onClick: ($event: any) => (toggleItem(index + '-package'))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("p", _hoisted_8, _toDisplayString(item.name), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(formatter).format(item.price)), 1)
                        ])
                      ]),
                      _createVNode(_unref(ChevronDownIcon), { class: "w-5 h-5 ml-4 text-primary-500" })
                    ], 8, _hoisted_5),
                    (isActive.value === index + '-package')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("ul", _hoisted_12, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (i, idx) => {
                                return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(i.item_name), 1))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(ButtonComponent, {
                                "show-icon": false,
                                "select-button": "",
                                text: selectedPackageId.value == item.id ? 'Selected' : 'Select',
                                selected: selectedPackageId.value == item.id,
                                onClick: _withModifiers(($event: any) => (selectedPackage(item.id)), ["prevent"])
                              }, null, 8, ["text", "selected", "onClick"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (services.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "w-full px-2 py-1 lg:w-1/2",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", {
                          class: "flex items-center justify-between w-full px-5 py-4 cursor-pointer",
                          onClick: ($event: any) => (toggleItem(index + '-service'))
                        }, [
                          _createElementVNode("p", _hoisted_20, _toDisplayString(service.name), 1),
                          _createVNode(_unref(ChevronDownIcon), { class: "w-5 h-5 ml-4 text-primary-500" })
                        ], 8, _hoisted_19),
                        (isActive.value === index + '-service')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "w-4 h-4 border-2 rounded-full cursor-pointer text-primary-500 border-primary-200 focus:ring-0 focus:ring-offset-0 focus:outline-0 focus:outline-offset-0 checked:border-primary-500",
                                        id: `parent-service-${service.id}`,
                                        type: "checkbox",
                                        value: service.id,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAllRiders).value = $event))
                                      }, null, 8, _hoisted_26), [
                                        [_vModelCheckbox, selectedAllRiders.value]
                                      ]),
                                      _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("label", {
                                          for: `parent-service-${service.id}`,
                                          class: "text-sm cursor-pointer"
                                        }, "All", 8, _hoisted_28)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(formatter).format(service.items.reduce((a, b) => a + b.item_price, 0))), 1)
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.items, (item, idx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "flex items-center justify-between",
                                    key: idx
                                  }, [
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("div", _hoisted_31, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "cursor-pointer h-4 w-4 text-primary-500 border-primary-200 border-2 focus:ring-0 focus:ring-offset-0 focus:outline-0 focus:outline-offset-0 checked:border-primary-500 rounded-[3px]",
                                          id: `service-${item.item_id}`,
                                          type: "checkbox",
                                          value: item.item_id,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedRiders).value = $event))
                                        }, null, 8, _hoisted_32), [
                                          [_vModelCheckbox, selectedRiders.value]
                                        ]),
                                        _createElementVNode("div", _hoisted_33, [
                                          _createElementVNode("label", {
                                            for: `service-${item.item_id}`,
                                            class: "text-sm cursor-pointer"
                                          }, _toDisplayString(item.item_name), 9, _hoisted_34)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(formatter).format(item.item_price)), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (allergyTests.value[0]?.items.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allergyTests.value, (allergyTest, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "w-full px-2 py-1 lg:w-1/2",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", {
                          class: "flex items-center justify-between w-full px-5 py-4 cursor-pointer",
                          onClick: ($event: any) => (toggleItem(index + '-allergy'))
                        }, [
                          _createElementVNode("p", _hoisted_41, _toDisplayString(allergyTest.name), 1),
                          _createVNode(_unref(ChevronDownIcon), { class: "w-5 h-5 ml-4 text-primary-500" })
                        ], 8, _hoisted_40),
                        (isActive.value === index + '-allergy')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("div", _hoisted_46, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "w-4 h-4 border-2 rounded-full cursor-pointer text-primary-500 border-primary-200 focus:ring-0 focus:ring-offset-0 focus:outline-0 focus:outline-offset-0 checked:border-primary-500",
                                        id: `parent-allergyTest-${allergyTest.id}`,
                                        type: "checkbox",
                                        value: allergyTest.id,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedAllRiders).value = $event))
                                      }, null, 8, _hoisted_47), [
                                        [_vModelCheckbox, selectedAllRiders.value]
                                      ]),
                                      _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("label", {
                                          for: `parent-allergyTest-${allergyTest.id}`,
                                          class: "text-sm cursor-pointer"
                                        }, "All", 8, _hoisted_49)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("p", _hoisted_50, _toDisplayString(_unref(formatter).format(allergyTest.items.reduce((a, b) => a + b.item_price, 0))), 1)
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allergyTest.items, (item, idx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "flex items-center justify-between",
                                    key: idx
                                  }, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _createElementVNode("div", _hoisted_52, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "cursor-pointer h-4 w-4 text-primary-500 border-primary-200 border-2 focus:ring-0 focus:ring-offset-0 focus:outline-0 focus:outline-offset-0 checked:border-primary-500 rounded-[3px]",
                                          id: `service-${item.item_id}`,
                                          type: "checkbox",
                                          value: item.item_id,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedRiders).value = $event))
                                        }, null, 8, _hoisted_53), [
                                          [_vModelCheckbox, selectedRiders.value]
                                        ]),
                                        _createElementVNode("div", _hoisted_54, [
                                          _createElementVNode("label", {
                                            for: `service-${item.item_id}`,
                                            class: "text-sm cursor-pointer"
                                          }, _toDisplayString(item.item_name), 9, _hoisted_55)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("p", _hoisted_56, _toDisplayString(_unref(formatter).format(item.item_price)), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createVNode(ButtonComponent, {
            secondary: "",
            "show-icon": false,
            text: "Go Back",
            onClick: _withModifiers(back, ["prevent"])
          }, null, 8, ["onClick"]),
          _createVNode(ButtonComponent, {
            disabled: !canContinue.value,
            text: "Continue",
            onClick: _withModifiers(proceed, ["prevent"])
          }, null, 8, ["disabled", "onClick"])
        ])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[4] || (_cache[4] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", { innerHTML: errorMsg.value }, null, 8, _hoisted_58)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }, 8, ["selected"]))
}
}

})